const firebaseConfig = {
  apiKey: "AIzaSyBxSRi5U8c7U4KttxKApdmhunomWNC_g2I",
  authDomain: "doortodoor-6eaa4.firebaseapp.com",
  projectId: "doortodoor-6eaa4",
  storageBucket: "doortodoor-6eaa4.appspot.com",
  messagingSenderId: "372271858643",
  appId: "1:372271858643:web:0669bb7f1af8ca21c5a526"
};
  export default firebaseConfig;